module.exports = __webpack_public_path__ + "static/pic-energy-fb583a13844db4d491df9a050fcbae12.svg";